import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { FormControlStatus, ValidationErrors } from '@angular/forms'
import { DestroySubscribers } from '@ftr/foundation'
import { Observable, takeUntil } from 'rxjs'
import { PasswordStrength } from '~app/shared/password/password-strength-meter/password-strength-meter.component'

@Component({
  selector: 'ftr-password-validation',
  templateUrl: './password-validation.component.html',
})
export class PasswordValidationComponent extends DestroySubscribers implements OnChanges, OnInit {
  @Input() fieldDirty: boolean
  @Input() validationErrors: ValidationErrors | null
  @Input() confirmPasswordValidationErrors?: ValidationErrors | null
  @Input() formStatusChanges$: Observable<FormControlStatus>

  protected passwordStrength: PasswordStrength = PasswordStrength.None
  protected validationPending: boolean = false
  private cachedStrengthValue: PasswordStrength | null

  ngOnInit(): void {
    this.formStatusChanges$.pipe(takeUntil(this.finalize)).subscribe(status => {
      this.validationPending = status === 'PENDING'
      if (!this.validationPending && this.cachedStrengthValue) {
        this.passwordStrength = this.cachedStrengthValue
        this.cachedStrengthValue = null
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setPasswordStrengthValue(changes)
  }

  private setPasswordStrengthValue(changes: SimpleChanges): void {
    // We only care about changes to the `weakPassword` validation error, so ignore any other change
    if (!changes.validationErrors || !this.fieldDirty) {
      return
    }
    const currentValidationErrors = changes.validationErrors.currentValue

    // If we have synchronous validation errors, reflect them immediately as a weak password
    if (currentValidationErrors?.minlength || currentValidationErrors?.required || currentValidationErrors?.error) {
      this.passwordStrength = PasswordStrength.Poor
      return
    }

    const strengthValue = currentValidationErrors?.weakPassword
      ? currentValidationErrors?.weakPassword.strength
      : PasswordStrength.Good

    // If we are currently running an async validation, we delay setting any strength value until
    // it has completed.
    if (this.validationPending) {
      this.cachedStrengthValue = strengthValue
    } else {
      this.passwordStrength = strengthValue
    }
  }
}
